import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import React from "react";
var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Dialog } from '@material-ui/core';
import isEmpty from 'lodash/isEmpty';
import { useEffect, useMemo, useState } from 'react';
import { InstantSearch } from 'react-instantsearch-dom';
import { FormattedMessage } from 'react-intl';
import { SLIDESHOW_CONTENT_TYPES_NAMES } from '@uno/common-cms';
import { GradientButton } from 'components/common/material-ui/custom-components';
import { Configure } from 'components/content/Algolia';
import { SearchBoxFilter } from 'components/content/ContentList/Filters';
import { AlgoliaSearchItemList } from 'components/content/SearchItemList';
import { useAlgoliaSearchClient, useDependency } from 'libs/content/hooks';
import { ButtonContainer, CloseButton, DeleteContentButton, Description, Img, Label, SearchBoxWrapper, SelectedContentContainer, Title } from './SlideshowEmbedDialog.style';

var SlideshowEmbedDialog = function SlideshowEmbedDialog(_ref) {
  var _slideshowEmbedData$c, _ref2, _linkedContent$previe, _linkedContent$label;

  var open = _ref.open,
      initialSlideshowEmbedData = _ref.initialSlideshowEmbedData,
      onClose = _ref.onClose,
      onConfirm = _ref.onConfirm;

  var _useState = useState(function () {
    return initialSlideshowEmbedData !== null && initialSlideshowEmbedData !== void 0 ? initialSlideshowEmbedData : null;
  }),
      slideshowEmbedData = _useState[0],
      setSlideshowEmbedData = _useState[1];

  var _useState2 = useState(null),
      selectedSlideshow = _useState2[0],
      setSelectedSlideshow = _useState2[1];

  var _useAlgoliaSearchClie = useAlgoliaSearchClient(),
      searchClient = _useAlgoliaSearchClie.searchClient,
      sortingIndexNames = _useAlgoliaSearchClie.sortingIndexNames;

  var contentTypeFilter = SLIDESHOW_CONTENT_TYPES_NAMES.map(function (contentTypeName) {
    return "contentType:".concat(contentTypeName);
  });
  var isSlideshowSelected = useMemo(function () {
    return !isEmpty(slideshowEmbedData === null || slideshowEmbedData === void 0 ? void 0 : slideshowEmbedData.contentId);
  }, [slideshowEmbedData]);
  var linkedContent = useDependency((_slideshowEmbedData$c = slideshowEmbedData === null || slideshowEmbedData === void 0 ? void 0 : slideshowEmbedData.contentId) !== null && _slideshowEmbedData$c !== void 0 ? _slideshowEmbedData$c : '');
  useEffect(function () {
    if (initialSlideshowEmbedData !== undefined) {
      setSlideshowEmbedData(initialSlideshowEmbedData);
    }
  }, [initialSlideshowEmbedData]);

  var handleConfirm = function handleConfirm() {
    if (slideshowEmbedData) {
      onConfirm(slideshowEmbedData);
    }
  };

  var handleClose = function handleClose() {
    onClose();

    if (slideshowEmbedData && slideshowEmbedData.contentId === '') {
      setSlideshowEmbedData(initialSlideshowEmbedData !== null && initialSlideshowEmbedData !== void 0 ? initialSlideshowEmbedData : null);
    }
  };

  var onItemClicked = function onItemClicked(item) {
    setSlideshowEmbedData(function (currentState) {
      var _item$previewImage;

      return _objectSpread(_objectSpread({}, currentState), {}, {
        contentId: item.id,
        label: item.label,
        previewImage: (_item$previewImage = item.previewImage) !== null && _item$previewImage !== void 0 ? _item$previewImage : ''
      });
    });
    setSelectedSlideshow(item);
  };

  var resetSelectedLink = function resetSelectedLink() {
    setSlideshowEmbedData(function (currentState) {
      return _objectSpread(_objectSpread({}, currentState), {}, {
        contentId: ''
      });
    });
    setSelectedSlideshow(null);
  };

  var ContentPreview = __jsx(SelectedContentContainer, null, __jsx(DeleteContentButton, {
    onClick: resetSelectedLink,
    "data-testid": "delete-content-button"
  }), __jsx(Img, {
    src: (_ref2 = (_linkedContent$previe = linkedContent === null || linkedContent === void 0 ? void 0 : linkedContent.previewImage) !== null && _linkedContent$previe !== void 0 ? _linkedContent$previe : selectedSlideshow === null || selectedSlideshow === void 0 ? void 0 : selectedSlideshow.previewImage) !== null && _ref2 !== void 0 ? _ref2 : ''
  }), __jsx(Label, null, (_linkedContent$label = linkedContent === null || linkedContent === void 0 ? void 0 : linkedContent.label) !== null && _linkedContent$label !== void 0 ? _linkedContent$label : selectedSlideshow === null || selectedSlideshow === void 0 ? void 0 : selectedSlideshow.label));

  if (!searchClient) {
    return null;
  }

  return __jsx(Dialog, {
    open: open,
    onClose: handleClose
  }, __jsx(CloseButton, {
    onClick: handleClose,
    "data-testid": "close-button"
  }), __jsx(FormattedMessage, {
    id: "slideshow-embed-modal.title",
    tagName: Title
  }), isSlideshowSelected ? ContentPreview : __jsx(React.Fragment, null, __jsx(FormattedMessage, {
    id: "slideshow-embed-modal.description",
    tagName: Description
  }), __jsx(InstantSearch, {
    indexName: sortingIndexNames.modificationDate.desc,
    searchClient: searchClient
  }, __jsx(SearchBoxWrapper, null, __jsx(SearchBoxFilter, {
    fieldLabelId: "filters.search"
  })), __jsx(Configure, {
    hitsPerPage: 15,
    facetFilters: [contentTypeFilter]
  }), __jsx(AlgoliaSearchItemList, {
    onClick: onItemClicked
  }))), __jsx(ButtonContainer, null, __jsx(GradientButton, {
    disabled: isEmpty(slideshowEmbedData === null || slideshowEmbedData === void 0 ? void 0 : slideshowEmbedData.contentId),
    onClick: handleConfirm
  }, __jsx(FormattedMessage, {
    id: "slideshow-embed-modal.confirm"
  }))));
};

export default SlideshowEmbedDialog;